import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ShadeToolsService} from '../../../core/services/shade-tools.service';

@Component({
    selector: 'motn-info-circle',
    templateUrl: './info-circle.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./info-circle.component.scss'],
})
export class InfoCircleComponent {
  @Input() title: string = '';
  @Input() message: string = '';


  constructor(
    private shadeTools: ShadeToolsService,
  ) {
  }


  onClick() {
    this.shadeTools.infoDialog(
      this.message,
      this.title,
    );
  }
}
